import { Timestamp } from '../Timestamp'

export interface GM {
  date: Timestamp
  proxyNoticeUrl?: string
  type: GeneralMeetingType
  organizationId: string
}

export enum GeneralMeetingType {
  annual = 'annual',
  extraordinary = 'extraordinary',
  special = 'special',
  general = 'general',
  court_ordered = 'court_ordered',
  postal_ballot = 'postal_ballot',
  bond_holder = 'bond_holder',
}
